var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClampUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1165,
    height: 487,
    viewBox: "0 0 1165 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.8 345.704C403.422 345.704 381.693 342.385 342.218 335.835C281.427 325.745 279.517 324.794 277.098 323.584C271.574 320.826 267.871 315.287 266.034 307.085C262.155 303.751 258.946 299.119 257.515 293.388C229.163 293.55 189.725 293.705 156.07 293.705C126.191 293.705 105.657 293.58 95.0286 293.344C81.7819 293.042 70.4011 288.063 62.1182 278.939C54.3221 270.354 50.2655 259.106 48.6797 248.507H25.9847V238.719H21.9059V184.759H25.9847V177.42H30.8747V172.53H50.8334C53.7468 151.288 71.1756 137.444 81.6196 132.413L84.651 130.953H256.704V106.119L267.849 108.597C270.578 102.321 275.173 94.2146 281.59 84.3607L296.651 56.3846V22.2277L311.749 3.77373H358.614V0.513672H410.945V38.6387L413.467 345.704H406.792H406.8Z",
    fill: "url(#paint0_linear_3300_35244)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M683.986 308.761V112.279H712.522V147.336L739.429 156.305V265.554L712.522 275.334V308.761H683.986Z",
    stroke: "black",
    strokeWidth: 1.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0602 201.959H124.716V228.047H79.0602V201.959Z",
    stroke: "black",
    strokeWidth: 1.22
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M517.671 382.952H395.382V340.557H529.089L684.805 342.187H999.504V383.763H691.332",
    fill: "url(#paint1_linear_3300_35244)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M362.686 396.81H281.25V400.07H269.84V396.81H262.501V381.321H267.391V346.264H262.501V330.775H267.391V325.885H281.25V330.775H330.933L362.686 396.81Z",
    fill: "url(#paint2_linear_3300_35244)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M395.382 40.5359L282.062 29.937V25.0469H269.014V29.937H260.045V44.6146H269.014V81.3014H260.045V93.5303H269.014V100.05H280.424V93.5303L395.375 81.3014V40.5359H395.382Z",
    fill: "url(#paint3_linear_3300_35244)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0748 187.281V234.567",
    stroke: "black",
    strokeWidth: 1.22
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6024 187.281V234.567",
    stroke: "black",
    strokeWidth: 1.22
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7524 187.281V234.567",
    stroke: "black",
    strokeWidth: 1.22
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M406.8 330.953C401.91 330.953 286.952 312.019 283.692 310.389C281.081 309.084 279.886 301.693 279.613 298.16C276.891 297.349 271.463 293.919 271.463 286.75C271.463 279.581 267.111 278.327 264.943 278.6C220.379 278.873 124.067 279.249 95.3679 278.6C66.669 277.951 61.6683 248.433 62.7599 233.763H40.7508V223.975H29.6873V199.518H40.7508V192.179H45.6409V187.289H65.2086V177.508C65.8577 160.552 80.6976 149.245 88.0364 145.712H271.47V124.514C273.919 125.06 278.971 124.839 279.62 119.624C280.269 114.409 289.673 98.9719 294.298 91.906L311.417 60.1094V27.5014L317.657 20.7452L404.447 14.9258L406.807 330.967L406.8 330.953Z",
    fill: "url(#paint4_linear_3300_35244)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M400.272 196.25V228.047",
    stroke: "black",
    strokeWidth: 1.22
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M406.8 196.25V228.047",
    stroke: "black",
    strokeWidth: 1.22
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M413.32 196.25V228.047",
    stroke: "black",
    strokeWidth: 1.22
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M600.5 204.039H558.769C557.033 204.039 555.626 205.446 555.626 207.181V216.305C555.626 218.04 557.033 219.447 558.769 219.447H600.5C602.236 219.447 603.642 218.04 603.642 216.305V207.181C603.642 205.446 602.236 204.039 600.5 204.039Z",
    stroke: "black",
    strokeWidth: 1.22
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M591.864 204.408V219.086",
    stroke: "black",
    strokeWidth: 1.22
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M998.685 29.9358V113.097H935.092V135.106L962.81 144.886V279.404L935.092 289.192V308.76H1000.32V401.701H1075.32L1077.77 428.607H1108.75V395.999H1139.72V328.335H1108.75L1107.12 103.317H1111.19V93.5365H1141.36V24.2418H1112.82L1103.04 14.4616H1069.62L1053.38 14.4395L1002.77 22.6117V29.9506H998.692L998.685 29.9358Z",
    fill: "#E3E1D5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.77 332.399V329.139H1139.72V395.992H1152.77M1152.77 332.399H1160.92V344.628H1152.77M1152.77 332.399V344.628V332.399ZM1152.77 344.635V382.141V344.635ZM1152.77 395.992V382.133V395.992ZM1152.77 395.992H1160.92V382.133H1152.77",
    fill: "url(#paint5_linear_3300_35244)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.88 401.701C1068.53 415.56 1067.99 442.466 1084.29 444.908C1131.9 444.251 1150.32 444.635 1153.59 444.908L1165 484.854L309.78 486.484V403.323L1072.88 401.693V401.701Z",
    fill: "#E3E1D5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M400.272 330.141V402.512H308.961L311.41 356.045C303.798 349.252 288.582 310.935 288.582 303.109L400.272 330.141Z",
    fill: "#E3E1D5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M388.405 51.798H311.41V27.4877C313.976 18.2164 321.522 19.1236 327.636 18.7327L388.176 14.9121L388.405 51.798Z",
    fill: "#E3E1D5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.96 24.5723H1142.05V93.5277H1151.96V24.5723Z",
    fill: "url(#paint6_linear_3300_35244)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.11 29.1152H1151.96V41.3442H1160.11V29.1152Z",
    fill: "url(#paint7_linear_3300_35244)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.32 78.0391H1151.96V91.898H1160.32V78.0391Z",
    fill: "url(#paint8_linear_3300_35244)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M417.398 318.885V313.302H440.226C457.183 313.302 461.424 302.128 461.424 296.544V257.438H457.345V244.87L454.896 173.643V164.563H458.975V128.946C458.975 110.507 449.195 105.904 444.297 105.904L410.635 107.254L417.391 318.893L417.398 318.885Z",
    fill: "url(#paint9_linear_3300_35244)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M371.104 131V127L381.655 130V127L392.207 130V127L402.759 130V127L415.069 131",
    stroke: "url(#paint10_linear_3300_35244)",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M359.672 146.5H299V152.5H371.103V131H359.672V146.5Z",
    fill: "url(#paint11_linear_3300_35244)",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M427 131V147.581L411 154V131H427Z",
    fill: "url(#paint12_linear_3300_35244)",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M410.945 57.0412L410.635 38.9043V40.5343H999.497V82.1112H692.748L635.985 81.2925H410.628",
    fill: "url(#paint13_linear_3300_35244)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M931.832 389.471L526.64 383.762H518.49V391.101H512.781V400.069L931.832 395.991V389.471Z",
    fill: "url(#paint14_linear_3300_35244)",
    stroke: "black",
    strokeWidth: 1.22
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.69 14.4238H1053.37C1048.56 14.4238 1044.72 18.4288 1044.92 23.2304L1048.14 98.4921C1048.46 106.148 1058 109.452 1062.99 103.633L1105.1 54.555C1106.41 53.0209 1107.14 51.0737 1107.14 49.0528V22.869C1107.14 18.2002 1103.36 14.4238 1098.69 14.4238ZM1083.1 43.5284H1057.85V24.5728H1083.1V43.5284Z",
    fill: "#3184AD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M570.666 272.073H503.001V253.324H424.737L418.217 259.844L416.587 252.505L409.248 259.844V252.505L401.91 259.844L400.28 252.505L393.759 259.844V252.505L388.051 259.844L386.421 252.505L380.712 259.844L378.263 252.505L374.184 259.844L369.294 252.505H322.009L317.93 259.844L315.481 253.324L310.591 259.844L308.142 252.505L303.252 259.025L299.992 252.505L294.283 259.844L291.023 252.505L285.314 259.844L283.684 252.505L273.904 259.844L270.644 252.505L265.754 259.844L261.675 252.505L255.966 259.844L253.518 252.505L246.998 259.844L245.368 252.505L238.847 259.844L237.217 252.505L230.697 259.844L229.067 253.324L222.547 259.844L220.098 252.505L213.578 259.844L211.948 253.324L206.239 259.844L202.979 253.324L198.089 259.844L194.829 252.505L186.679 258.214L185.868 253.324L179.348 257.402L175.269 252.512L167.119 259.851L163.859 254.142L151.63 258.221L150.811 253.331L144.291 257.41L142.661 253.331L136.952 258.221L132.873 251.701L124.723 261.481V162.02L132.873 171.807L136.952 165.287L142.661 170.177L144.291 166.098L150.811 170.177L151.63 165.287L163.859 169.366L167.119 163.657L175.269 170.996L179.348 166.106L185.868 170.185L186.679 165.295L194.829 171.003L198.089 163.664L202.979 170.185L206.239 163.664L211.948 170.185L213.578 163.664L220.098 171.003L222.547 163.664L229.067 170.185L230.697 163.664L237.217 171.003L238.847 163.664L245.368 171.003L246.998 163.664L253.518 171.003L255.966 163.664L261.675 171.003L265.754 163.664L270.644 171.003L273.904 163.664L283.684 171.003L285.314 163.664L291.023 171.003L294.283 163.664L299.992 171.003L303.252 164.483L308.142 171.003L310.591 163.664L315.481 170.185L317.93 163.664L322.009 171.003H369.294L374.184 163.664L378.263 171.003L380.712 163.664L386.421 171.003L388.051 163.664L393.759 171.003V163.664L400.28 171.003L401.91 163.664L409.248 171.003V163.664L416.587 171.003L418.217 163.664L424.737 170.185H503.001V151.436H570.666",
    fill: "url(#paint15_linear_3300_35244)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M570.666 272.073H503.001V253.324H424.737L418.217 259.844L416.587 252.505L409.248 259.844V252.505L401.91 259.844L400.279 252.505L393.759 259.844V252.505L388.051 259.844L386.421 252.505L380.712 259.844L378.263 252.505L374.184 259.844L369.294 252.505H322.009L317.93 259.844L315.481 253.324L310.591 259.844L308.142 252.505L303.252 259.025L299.992 252.505L294.283 259.844L291.023 252.505L285.314 259.844L283.684 252.505L273.904 259.844L270.644 252.505L265.754 259.844L261.675 252.505L255.966 259.844L253.518 252.505L246.998 259.844L245.368 252.505L238.847 259.844L237.217 252.505L230.697 259.844L229.067 253.324L222.547 259.844L220.098 252.505L213.578 259.844L211.948 253.324L206.239 259.844L202.979 253.324L198.089 259.844L194.829 252.505L186.679 258.214L185.868 253.324L179.348 257.402L175.269 252.512L167.119 259.851L163.859 254.142L151.63 258.221L150.811 253.331L144.291 257.41L142.661 253.331L136.952 258.221L132.873 251.701L124.723 261.481V162.02L132.873 171.807L136.952 165.287L142.661 170.177L144.291 166.098L150.811 170.177L151.63 165.287L163.859 169.366L167.119 163.657L175.269 170.996L179.348 166.106L185.868 170.185L186.679 165.295L194.829 171.003L198.089 163.664L202.979 170.185L206.239 163.664L211.948 170.185L213.578 163.664L220.098 171.003L222.547 163.664L229.067 170.185L230.697 163.664L237.217 171.003L238.847 163.664L245.368 171.003L246.998 163.664L253.518 171.003L255.966 163.664L261.675 171.003L265.754 163.664L270.644 171.003L273.904 163.664L283.684 171.003L285.314 163.664L291.023 171.003L294.283 163.664L299.992 171.003L303.252 164.483L308.142 171.003L310.591 163.664L315.481 170.185L317.93 163.664L322.009 171.003H369.294L374.184 163.664L378.263 171.003L380.712 163.664L386.421 171.003L388.051 163.664L393.759 171.003V163.664L400.279 171.003L401.91 163.664L409.248 171.003V163.664L416.587 171.003L418.217 163.664L424.737 170.185H503.001V151.436H570.666",
    stroke: "url(#paint16_linear_3300_35244)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M124.716 201.959H36.6646V222.67H124.716V201.959Z",
    fill: "url(#paint17_linear_3300_35244)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9133 201.959H7.302V225.465H21.9133V201.959Z",
    fill: "url(#paint18_linear_3300_35244)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30195 207.32H0V220.102H7.30195V207.32Z",
    fill: "url(#paint19_linear_3300_35244)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M657.898 61.7317H626.92V81.2994L600.013 115.537V107.387L604.092 104.127V87.0082H567.405V107.387H572.296V153.043L570.666 157.122V171.799H557.625V193.808H545.396V227.235H555.184L572.303 241.913L570.673 274.528L572.303 331.594H528.277V382.958H518.497L519.308 391.109H512.788V400.077L690.521 397.629V381.321H684.812V309.578H712.53V274.521L738.618 265.552V157.122L712.53 148.153V111.466H683.993C683.182 91.6254 682.039 49.3405 683.993 38.9039C685.948 28.4672 672.848 30.7537 666.055 33.1951C666.328 36.728 666.705 45.424 666.055 51.9441C665.406 58.4642 660.347 61.1859 657.905 61.7243L657.898 61.7317Z",
    fill: "url(#paint20_linear_3300_35244)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.12 103.307L1057.85 152.569H1108.34L1107.12 103.307Z",
    fill: "#E3E1D5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.12 310.512L1057.85 261.25H1108.34L1107.12 310.512Z",
    fill: "#E3E1D5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.34 272.071H1048.01L1031.04 245.718V180.826L1048.01 151.412H1108.34V272.071Z",
    fill: "url(#paint21_linear_3300_35244)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.56 221.928H998.767V189.312C1007.13 189.578 1025.47 189.947 1030.56 189.312C1031.23 202.36 1031.19 216.359 1030.56 221.928Z",
    fill: "url(#paint22_linear_3300_35244)",
    stroke: "black",
    strokeWidth: 0.39
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M477.083 193.805H545.567V227.231C527.356 226.958 488.169 226.582 477.083 227.231C473.823 214.184 475.726 199.513 477.083 193.805Z",
    fill: "url(#paint23_linear_3300_35244)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M490.854 193.807H485.602V226.909H490.854V193.807Z",
    fill: "url(#paint24_radial_3300_35244)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M499.911 193.807H494.659V226.909H499.911V193.807Z",
    fill: "url(#paint25_radial_3300_35244)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M602.61 204.408H545.566V215.007H602.61V204.408Z",
    fill: "url(#paint26_linear_3300_35244)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M450.464 228.049H149.174V195.434C225.763 195.684 388.051 196.024 448.591 195.537C455.649 195.478 461.756 200.479 463.054 207.412C463.556 210.111 463.77 212.73 463.696 215.164C463.49 222.333 457.641 228.042 450.464 228.042V228.049Z",
    fill: "url(#paint27_linear_3300_35244)",
    stroke: "black",
    strokeWidth: 1.22
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.315 195.44H149.174V228.048H135.315V241.095H124.716V184.029H135.315V195.44Z",
    fill: "url(#paint28_linear_3300_35244)",
    stroke: "black",
    strokeWidth: 1.22
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M413.468 196.25H448.967C457.744 196.25 464.861 203.375 464.861 212.144C464.861 220.921 457.737 228.039 448.967 228.039H413.468V196.242V196.25Z",
    fill: "url(#paint29_linear_3300_35244)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M400.634 195.602H395.382V228.704H400.634V195.602Z",
    fill: "url(#paint30_radial_3300_35244)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M409.691 195.602H404.44V228.704H409.691V195.602Z",
    fill: "url(#paint31_radial_3300_35244)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M998.685 113.096H935.092V135.105L962.81 144.885V279.41L935.092 289.191V308.758H1000.32L998.685 113.096Z",
    fill: "url(#paint32_linear_3300_35244)",
    stroke: "black",
    strokeWidth: 1.03
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M684.03 111.465V148.683L713.327 162.431V255.925L683.234 277.234L684.893 309.576H714.19V274.52H741.76V157.12L714.19 148.152V111.465H684.03Z",
    fill: "url(#paint33_linear_3300_35244)",
    stroke: "black",
    strokeWidth: 1.03
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M640.934 83.2453L601.186 122.993H579.634V159.82L601.762 173.104V241.093L579.634 265.639V339.735H538.832V388.813H666.387V81.8145L640.934 83.2453Z",
    fill: "#3184AD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M666.387 178.318H601.194V196.256H666.387V178.318Z",
    fill: "#55A2D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3300_35244",
    x1: 21.9133,
    y1: 173.105,
    x2: 413.467,
    y2: 173.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3300_35244",
    x1: 697.439,
    y1: 376.757,
    x2: 697.439,
    y2: 367.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3300_35244",
    x1: 262.494,
    y1: 362.977,
    x2: 362.686,
    y2: 362.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3300_35244",
    x1: 260.045,
    y1: 62.545,
    x2: 395.382,
    y2: 62.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3300_35244",
    x1: 29.6799,
    y1: 172.936,
    x2: 406.8,
    y2: 172.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3300_35244",
    x1: 1139.72,
    y1: 362.565,
    x2: 1160.92,
    y2: 362.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3300_35244",
    x1: 1142.05,
    y1: 59.0463,
    x2: 1151.96,
    y2: 59.0463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3300_35244",
    x1: 1151.96,
    y1: 35.2371,
    x2: 1160.11,
    y2: 35.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3300_35244",
    x1: 1151.96,
    y1: 84.9649,
    x2: 1160.32,
    y2: 84.9649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3300_35244",
    x1: 410.635,
    y1: 212.387,
    x2: 461.417,
    y2: 212.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3300_35244",
    x1: 371.104,
    y1: 129,
    x2: 415.069,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3300_35244",
    x1: 299,
    y1: 141.75,
    x2: 371.103,
    y2: 141.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3300_35244",
    x1: 427,
    y1: 142.5,
    x2: 411,
    y2: 142.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3300_35244",
    x1: 704.181,
    y1: 2.28392,
    x2: 705.501,
    y2: 89.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3300_35244",
    x1: 512.781,
    y1: 391.919,
    x2: 931.832,
    y2: 391.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3300_35244",
    x1: 124.716,
    y1: 211.739,
    x2: 570.666,
    y2: 211.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#9B9B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A4A5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AEB0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9FA3A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#788187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#657076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3300_35244",
    x1: 123.609,
    y1: 211.739,
    x2: 570.666,
    y2: 211.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3300_35244",
    x1: 36.6646,
    y1: 212.314,
    x2: 124.716,
    y2: 212.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3300_35244",
    x1: 7.302,
    y1: 213.708,
    x2: 21.9133,
    y2: 213.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3300_35244",
    x1: 0,
    y1: 213.708,
    x2: 7.30195,
    y2: 213.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3300_35244",
    x1: 512.781,
    y1: 215.604,
    x2: 738.61,
    y2: 215.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3300_35244",
    x1: 1031.04,
    y1: 211.738,
    x2: 1108.34,
    y2: 211.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDB8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B1AEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3300_35244",
    x1: 1014.9,
    y1: 151.187,
    x2: 1014.9,
    y2: 215.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3300_35244",
    x1: 475.283,
    y1: 210.518,
    x2: 545.567,
    y2: 210.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#541513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CB9552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AB6B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9C530D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3300_35244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(488.228 210.358) scale(11.8527 11.8528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3300_35244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(497.285 -136.669) scale(0.368785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3300_35244",
    x1: 545.566,
    y1: 209.704,
    x2: 602.61,
    y2: 209.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3300_35244",
    x1: 306.439,
    y1: 157.309,
    x2: 306.439,
    y2: 221.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3300_35244",
    x1: 124.716,
    y1: 212.559,
    x2: 149.174,
    y2: 212.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDB8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B1AEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3300_35244",
    x1: 413.468,
    y1: 212.152,
    x2: 464.869,
    y2: 212.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3300_35244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(398.008 212.153) scale(0.368785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3300_35244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(407.065 212.153) scale(0.368785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3300_35244",
    x1: 935.092,
    y1: 210.927,
    x2: 1000.32,
    y2: 210.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3300_35244",
    x1: 683.234,
    y1: 210.521,
    x2: 741.76,
    y2: 210.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClampUnit);
export default __webpack_public_path__ + "static/media/ClampUnit.59d5f06b2c1350b627c62628d5651e54.svg";
export { ForwardRef as ReactComponent };